export default {
  'SET_RESPONSE'(state, data) {
    state.response = data;
  }
};
